import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { I4goPaymentResponseDTO } from "../../models/DTO/I4goPaymentRequest.dto";
import { OOVenue } from "../../models/oo-venue";

declare var Accept: any;

@Component({
	selector: "app-auth-net-payment",
	templateUrl: "./auth-net-payment.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class AuthNetPaymentComponent implements OnInit {
	@Input() billingZip: string;
	@Input() firstName: string;
	@Input() lastName: string;
	@Input() transactionAmount: number;
	@Input() venueKey: number;

	paymentData: {
		cardNumber?: string;
		expirationMonth?: string; //MM format;
		expirationYear?: string; //YYYY format;
		cvvCode?: string;
		fullName?: string;
		zipCode?: string;
	} = {};

	@Output() i4goResponse: EventEmitter<I4goPaymentResponseDTO> = new EventEmitter<I4goPaymentResponseDTO>();

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.paymentData.fullName = `${this.firstName} ${this.lastName}`;
		this.paymentData.zipCode = this.billingZip || undefined;

		if (this.venueKey === 6383) {
			this.paymentData.cardNumber = "4321000000001119";
			this.paymentData.cvvCode = "333";
			this.paymentData.expirationMonth = "12";
			this.paymentData.expirationYear = new Date().getFullYear().toString();
		}
	}

	async getVenue(venueKey: number): Promise<OOVenue> {
		const resp = await this.focuslink.getOOVenue(venueKey);
		return new OOVenue(resp);
	}

	async submitPayment() {
		this.app.loading(true);
		const authData: any = {};
		authData.clientKey = (await this.focuslink.authnetGetMerchantDetailsRequest(this.venueKey)).publicClientKey;
		authData.apiLoginID = await (await this.getVenue(this.venueKey)).ccProcessorApiKey;

		const cardData: any = {};
		cardData.cardNumber = this.paymentData.cardNumber.replace(/\s/g, "");
		cardData.month = this.paymentData.expirationMonth;
		cardData.year = this.paymentData.expirationYear.substr(2);
		cardData.cardCode = this.paymentData.cvvCode.toString();
		cardData.fullName = this.paymentData.fullName;
		cardData.zip = this.paymentData.zipCode;

		const secureData: any = {};
		secureData.authData = authData;
		secureData.cardData = cardData;

		try {
			await new Promise((resolve, reject) => {
				Accept.dispatchData(secureData, (response) => {
					if (response.messages.resultCode === "Error") {
						var i = 0;
						while (i < response.messages.message.length) {
							console.error(response.messages.message[i].code + ": " + response.messages.message[i].text);
							i = i + 1;
						}
						reject();
					} else {
						this.app.devLog(response);
						resolve(true);
						this.i4goResponse.emit(
							new I4goPaymentResponseDTO({
								token: JSON.stringify(response.opaqueData),
								displayName: response.displayName,
								postalCode: this.paymentData.zipCode,
								cardNumber: this.paymentData.cardNumber,
								expirationMonth: this.paymentData.expirationMonth,
								expirationYear: this.paymentData.expirationYear,
								securityCode: this.paymentData.cvvCode,
								firstName: this.firstName,
								lastName: this.lastName,
								amount: this.transactionAmount,
							})
						);
					}
				});
			});
			this.app.loading(false);
		} catch (error) {
			this.app.msgSvc.add({
				severity: "error",
				detail: "Error pre-authorizing payment",
				key: "sidebar",
			});
			console.error(error);
			this.app.loading(false);
			return;
		}
	}
}
